import React, { useCallback, useEffect, useState } from "react";
import ConfirmationPage from "../../common/ConfirmationPage";
import { AiOutlineDelete } from "react-icons/ai";
import { LuPencilLine } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addContest,
  deleteContest,
  getAllContest,
  getSingleContest,
} from "../../redux/services/contestSlice";
import { toast } from "react-toastify";
import { convertIstToUtc, convertUtcToIst } from "../../common/TimeUtils";
import moment from "moment-timezone";
import Table from "../../common/Table";
import { exportToTablePDF } from "../../common/PdfFormat";
import Model from "../../common/Model";
import { DatePicker } from "antd";
import { GoInfo } from "react-icons/go";

const Contest = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getContestData = useSelector((state) => state?.contest?.contestData);
  const getsingleContestData = useSelector(
    (state) => state.contest.singleContestData
  );
  const [page, setPage] = useState(0);
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [dateModel, setDateSelectModel] = useState(false);
  const [filter, setFilter] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [totalTime, setTotalTime] = useState();
  const [selectedContests, setSelectedContests] = useState([]);
  const [contestDataArray, setContestDataArray] = useState([]);
  const handleCheckboxChange = (contestId) => {
    if (selectedContests.includes(contestId)) {
      setSelectedContests(selectedContests.filter((id) => id !== contestId));
    } else {
      setSelectedContests([...selectedContests, contestId]);
    }
  };
  const getAllContestApi = useCallback(async () => {
    try {
      await dispatch(
        getAllContest({ page: page + 1, limit: pageLimit, filter, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, filter, searchData]);

  useEffect(() => {
    getAllContestApi();
  }, [getAllContestApi]);
  const deleteContestData = async () => {
    try {
      const response = await dispatch(deleteContest(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllContestApi();
    } catch (error) {}
  };
  const handleDelete = (questionId) => {
    setItemToDelete(questionId);
    setConfirm(true);
  };
  const filterOptions = [
    { value: "", label: "All" },
    { value: "upcoming", label: "Upcoming" },
    { value: "ongoing", label: "Ongoing" },
    { value: "completed", label: "Completed" },
  ];

  const handleCopyContest = () => {
    if (selectedContests.length === 0) {
      toast.error("Please select at least one contest to copy.");
      return;
    }
    setContestDataArray([]);
    selectedContests.forEach((contestId) => {
      dispatch(getSingleContest(contestId)).then((response) => {
        setContestDataArray((prevArray) => [
          ...prevArray,
          response.payload.data,
        ]);
      });
    });
    setDateSelectModel(true);
  };

  const columns = [
    {
      label: "Select",
      key: "select",
      render: (_, row) => (
        <input
          type="checkbox"
          checked={selectedContests.includes(row._id)}
          onChange={() => handleCheckboxChange(row._id)}
        />
      ),
    },
    {
      label: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { label: "Name", key: "name", render: (_, row) => row?.name || "-" },
    {
      label: "Contest Type",
      key: "contest-type",
      render: (_, row) =>
        row?.["contest-type"]?.name ? row?.["contest-type"]?.name : "-",
    },
    {
      label: "F.S/T.S",
      key: "f.s/t.s",
      render: (_, row) =>
        row?.filledSpots || row?.totalSpots
          ? row?.filledSpots + "/" + row?.totalSpots
          : "-",
    },
    {
      label: "Start Date",
      key: "start-date",
      render: (_, row) =>
        row.startDate
          ? moment(convertUtcToIst(row.startDate)).format("YYYY-MM-DD hh:mm A")
          : "-",
    },
    {
      label: "End Date",
      key: "end-date",
      render: (_, row) =>
        row.endDate
          ? moment(convertUtcToIst(row.endDate)).format("YYYY-MM-DD hh:mm A")
          : "-",
    },
    {
      label: "Status",
      key: "status",
      render: (_, row) =>
        filterOptions ? (
          <li
            className={`py-1 px-2 max-w-[7rem] mx-auto flex justify-center text-sm leading-5 font-semibold rounded-full ${
              row?.status === "completed"
                ? "bg-red-100 text-red-500"
                : row?.status === "ongoing"
                ? "bg-green-100 text-green-500"
                : row?.status === "upcoming"
                ? "bg-blue-100 text-primary"
                : ""
            }`}
          >
            {row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}
          </li>
        ) : (
          row?.status
        ),
    },
  ];

  const actions = [
    {
      icon: <GoInfo className="w-6 h-6" />,
      // onClick: (row) => navigate(`/contest-leaderboard?contestId=${row._id}`),
       onClick: (row) => {
    const now = new Date();
    const endDate = new Date(row.endDate);

    if (now >= endDate) {
      navigate(`/contest-leaderboard?contestId=${row._id}`);
    } else {
      // optional: toast / alert
      toast.info("Contest is still running. Leaderboard will be available after it ends.");
    }
  },
    },
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => navigate(`/edit-contest?contestId=${row._id}`),
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => handleDelete(row._id),
    }
  ];

  const exportToPDF = () => {
    const headersConfig = [
      {
        label: "S/N",
        key: "index",
        render: (_, __, index) => index + 1,
      },
      { label: "Name", key: "name", render: (_, row) => row?.name || "-" },
      {
        label: "Contest Type",
        key: "contest-type",
        render: (_, row) =>
          row?.["contest-type"]?.name ? row?.["contest-type"]?.name : "-",
      },
      {
        label: "F.S/T.S",
        key: "f.s/t.s",
        render: (_, row) =>
          row?.filledSpots || row?.totalSpots
            ? row?.filledSpots + "/" + row?.totalSpots
            : "-",
      },
      {
        label: "Start Date",
        key: "start-date",
        render: (_, row) =>
          row.startDate
            ? moment(convertUtcToIst(row.startDate)).format(
                "YYYY-MM-DD hh:mm A"
              )
            : "-",
      },
      {
        label: "End Date",
        key: "end-date",
        render: (_, row) =>
          row.endDate
            ? moment(convertUtcToIst(row.endDate)).format("YYYY-MM-DD hh:mm A")
            : "-",
      },
      {
        label: "Status",
        key: "status",
        render: (_, row) => row?.status,
      },
    ];
    const data = getContestData?.contest_data || [];
    exportToTablePDF({
      tableName: "Contest Data",
      data,
      headersConfig,
      pdfName: "contest_data.pdf",
    });
  };
  const calculateTimeDifference = (start, end) => {
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffInMilliseconds = endDate - startDate;
      const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
      const hours = Math.floor(diffInMinutes / 60);
      const minutes = diffInMinutes % 60;
      return { hours, minutes };
    }
    return { hours: 0, minutes: 0 };
  };
  useEffect(() => {
    if (startDate && endDate) {
      const { hours, minutes } = calculateTimeDifference(startDate, endDate);
      setTotalTime(`${hours} hours ${minutes} minutes`);
    }
  }, [startDate, endDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newContests = contestDataArray.map((contest) => {
      return {
        name: contest?.name || undefined,
        contestTypeId: contest?.contestTypeId || undefined,
        startDate: convertIstToUtc(startDate),
        endDate: convertIstToUtc(endDate) || undefined,
        totalSpots: contest?.totalSpots || undefined,
        fees: contest?.fees || undefined,
        classesFees: contest?.classesFees || undefined,
        winningAmountPerFee: contest?.winningAmountPerFee || undefined,
        winnerPercentage: contest?.winnerPercentage || undefined,
        ranks:
          contest?.ranks?.map(({ startPlace, price }) => ({
            startPlace,
            price,
          })) || [],
        pricePool: contest?.pricePool,
        totalQuestions: contest?.totalQuestions || undefined,
        totalTime: totalTime || undefined,
        totalMarks: contest?.totalMarks || undefined,
        classesIds: contest?.classesIds || [],
      };
    });

    try {
      for (const payload of newContests) {
        const response = await dispatch(addContest(payload));
        if (response?.payload?.status === 200) {
          toast.success(response?.payload?.message, {
            autoClose: 2000,
            pauseOnHover: false,
          });
        }
      }
      setSelectedContests([]);
      setDateSelectModel(false);
      getAllContestApi();
    } catch (error) {}
  };
  return (
    <>
      <Table
        title="Contest"
        buttonTitle="Add Contest"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => navigate("/add-contest")}
        copyButton="Copy Contest"
        handleCopy={handleCopyContest}
        columns={columns}
        data={getContestData?.contest_data}
        actions={actions}
        pageCount={getContestData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        filterOptions={filterOptions}
        selectedFilter={filter}
        onFilterChange={(e) => setFilter(e ? e.value : "")}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />

      {confirm && (
        <ConfirmationPage
          topicName="Contest"
          confirm={confirm}
          onDelete={deleteContestData}
          onCancel={() => setConfirm(false)}
        />
      )}
      {dateModel && (
        <Model
          closeModal={() => setDateSelectModel(false)}
          isForm={true}
          handleSubmit={handleSubmit}
          title={`${getsingleContestData?.name} Contest Copy`}
        >
          <div className="flex  gap-5">
            <button
              type="button"
              className="bg-primary text-white px-4 py-2 rounded-xl font-semibold"
              onClick={() => {
                const startTime = moment().set({
                  hour: 8,
                  minute: 0,
                  second: 0,
                });
                const endTime = moment()
                  .set({
                    hour: 8,
                    minute: 0,
                    second: 0,
                  })
                  .add(1, "day");
                setStartDate(startTime);
                setEndDate(endTime.add());
              }}
            >
              Today
            </button>
            <button
              type="button"
              className="bg-primary text-white px-4 py-2 rounded-xl font-semibold"
              onClick={() => {
                const startTomorrow = moment()
                  .add(1, "days")
                  .set({ hour: 8, minute: 0, second: 0 });
                const endTomorrow = moment()
                  .add(2, "days")
                  .set({ hour: 8, minute: 0, second: 0 });
                setStartDate(startTomorrow);
                setEndDate(endTomorrow.add());
              }}
            >
              Tomorrow
            </button>
          </div>

          <div className="flex flex-col mt-3">
            <label className="text-sm font-medium text-foreground mt-1">
              Start Date
            </label>
            <DatePicker
              showTime
              value={startDate}
              onChange={(date) => {
                setStartDate(date);
                setEndDate(null);
                setTotalTime("");
              }}
              format="DD-MM-YYYY HH:mm"
              className="w-full px-4 py-2 border border-border rounded-xl"
              disabledDate={(current) =>
                current && current < moment().startOf("day")
              }
              disabledTime={(current) => {
                if (current && current.isSame(moment(), "day")) {
                  return {
                    disabledHours: () =>
                      [...Array(24).keys()].filter((h) => h < moment().hour()),
                    disabledMinutes: (selectedHour) => {
                      if (selectedHour === moment().hour()) {
                        return [...Array(60).keys()].filter(
                          (m) => m < moment().minute()
                        );
                      }
                      return [];
                    },
                    disabledSeconds: (selectedHour, selectedMinute) => {
                      if (
                        selectedHour === moment().hour() &&
                        selectedMinute === moment().minute()
                      ) {
                        return [...Array(60).keys()].filter(
                          (s) => s < moment().second()
                        );
                      }
                      return [];
                    },
                  };
                }
                return {};
              }}
            />
          </div>

          <div className="flex flex-col mt-3">
            <label className="text-sm font-medium text-foreground">
              End Date
            </label>
            <DatePicker
              showTime
              value={endDate}
              onChange={(date) => {
                setEndDate(date);
              }}
              format="DD-MM-YYYY HH:mm"
              className="w-full px-4 py-2 border border-border rounded-xl"
              disabled={!startDate}
              disabledDate={(current) =>
                current && current < moment(startDate).startOf("day")
              }
              disabledTime={(current) => {
                if (moment(startDate).isSame(current, "day")) {
                  return {
                    disabledHours: () =>
                      [...Array(24).keys()].filter(
                        (h) => h < moment(startDate).hour()
                      ),
                    disabledMinutes: (selectedHour) => {
                      if (selectedHour === moment(startDate).hour()) {
                        return [...Array(60).keys()].filter(
                          (m) => m < moment(startDate).minute()
                        );
                      }
                      return [];
                    },
                    disabledSeconds: (selectedHour, selectedMinute) => {
                      if (
                        selectedHour === moment(startDate).hour() &&
                        selectedMinute === moment(startDate).minute()
                      ) {
                        return [...Array(60).keys()].filter(
                          (s) => s < moment(startDate).second()
                        );
                      }
                      return [];
                    },
                  };
                }
                return {};
              }}
            />
          </div>

          <div className="mt-3">
            <label className="text-sm font-medium text-foreground">
              Total Time
            </label>
            <input
              type="text"
              placeholder="Total Time"
              className="w-full px-4 py-2 border border-border rounded-xl bg-background outline-none"
              value={totalTime}
              readOnly
            />
          </div>
        </Model>
      )}
    </>
  );
};

export default Contest;
